import { html } from 'lit';
const Inbox =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6 3.25A2.75 2.75 0 0 0 3.25 6v12A2.75 2.75 0 0 0 6 20.75h12A2.75 2.75 0 0 0 20.75 18V6A2.75 2.75 0 0 0 18 3.25zm13.25 9V6c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v6.25h1.836c.464 0 .909.184 1.237.513l2.414 2.414a.25.25 0 0 0 .177.073h3.172a.25.25 0 0 0 .177-.073l2.414-2.414a1.75 1.75 0 0 1 1.237-.513zm-14.5 1.5h1.836a.25.25 0 0 1 .177.073l2.414 2.414a1.75 1.75 0 0 0 1.237.513h3.172c.464 0 .909-.184 1.237-.513l2.414-2.414a.25.25 0 0 1 .177-.073h1.836V18c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
export default Inbox;
